import React, { createContext, useContext, useEffect, useState } from 'react';
import { message } from 'antd';
import { useAuthContext } from '../components/AuthProvider'; // Adjust path
import { usePosOperatorShop } from '../components/api/usePosOperatorShopid'; // Adjust path

export const TillContext = createContext();

export const TillProvider = ({ children }) => {
  const { token, loginUser } = useAuthContext();
  const { selectedShop } = usePosOperatorShop();
  const [tills, setTills] = useState([]);
  const [selectedTill, setSelectedTill] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!selectedShop?.shopId || !loginUser?.id || !token) {
      setError('Missing shop ID, user ID, or token');
      return;
    }

    const fetchTills = async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://api.synergytoss.net/api/v1/tillassignments/pos-operator/${loginUser.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) {
          throw new Error(`Failed to fetch till assignments: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        console.log('Till assignments response:', data);
        // Filter for tills that belong to the selected shop and have status "OPEN" (case-insensitive)
        const filteredTills = data.filter(assignment => 
          assignment.till.shopId === selectedShop.shopId && 
          assignment.till.status.toUpperCase() === 'OPEN'
        );
        setTills(filteredTills);
        if (filteredTills.length > 0) {
          const defaultTill = { till: filteredTills[0].till, assignmentId: filteredTills[0].id };
          setSelectedTill(defaultTill);
          sessionStorage.setItem('tos-selectedTill', JSON.stringify(defaultTill));
        } else {
          // setError('No tills available for this shop');
          // message.warning('No tills available for the selected shop');
        }
      } catch (err) {
        // console.error('Error fetching tills:', err);
        // setError(err.message);
        // message.error(`Error fetching tills: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchTills();
  }, [token, selectedShop, loginUser]);

  const selectTill = (tillId) => {
    const assignment = tills.find(t => t.till.id === tillId);
    if (assignment) {
      const newTill = { till: assignment.till, assignmentId: assignment.id };
      setSelectedTill(newTill);
      sessionStorage.setItem('tos-selectedTill', JSON.stringify(newTill));
    }
  };

  return (
    <TillContext.Provider value={{ tills, selectedTill, selectTill, loading, error }}>
      {children}
    </TillContext.Provider>
  );
};

export const useTillContext = () => useContext(TillContext);